module.exports = __webpack_public_path__ + "img/short-film-thumb.6ca6bbe9.jpg";